/**
 * SCREENSHOTS IN A PROBLEM REPORT (Jeremy, 3 Nov 2026: "both apps, yes to unlinked, same
 * wording and limits"). Up to five, pasted, dropped or picked in Report a problem and sent with
 * it. The same limits and messages as Canopy's note and report images (its NOTE_IMAGE_* in
 * shared/src/workflow.ts and web/src/noteImages.ts), with "report" for "note".
 *
 * The browser checks each file AS PICKED and then shrinks it (web/src/reportImages.ts); the API
 * holds what arrives to the same ceiling and these three kinds (api/src/db/images.ts). Kept here,
 * pure, so the browser's half is tested.
 */
export const REPORT_IMAGES_MAX = 5;
export const REPORT_IMAGE_BYTES_MAX = 5 * 1024 * 1024;
export const REPORT_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
/** The longest side an image is kept at. Wide enough to read a screen's text. */
export const REPORT_IMAGE_MAX_SIDE = 1600;
/**
 * Why a file cannot be added, or null. Checked on the file AS PICKED, before shrinking, so the
 * 5 MB limit means what a person would expect it to.
 */
export function imageRefusal(file, alreadyPending) {
    if (alreadyPending >= REPORT_IMAGES_MAX)
        return `A report can carry up to ${REPORT_IMAGES_MAX} images.`;
    if (!file.type.startsWith('image/'))
        return 'Only images can be added to a report.';
    if (file.size > REPORT_IMAGE_BYTES_MAX)
        return 'Each image must be 5 MB or smaller.';
    return null;
}
/** The size an image is drawn at: its own, or scaled down to fit the longest side. */
export function fitWithin(width, height, maxSide = REPORT_IMAGE_MAX_SIDE) {
    const longest = Math.max(width, height);
    if (longest <= maxSide)
        return { width, height };
    const scale = maxSide / longest;
    return { width: Math.max(1, Math.round(width * scale)), height: Math.max(1, Math.round(height * scale)) };
}
//# sourceMappingURL=images.js.map